import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RealEstateService {
  constructor(
    private config: ConfigService,
    private httpClient: HttpClient
  ) {}

  getProjectSetupData(body: { state: string; department: string; adaptive_id: string }): any {
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    return this.httpClient.post(
      this.config.getConfig('ApiBaseURLAWS').concat('/mmaps/real-estate/project'),
      body,
      {
        headers: {
          Authorization: userInfo.idToken,
          'Content-Type': 'application/json',
        },
      }
    );
  }

  getUopData(search?: string): any {
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    if (!search) {
      return this.httpClient.get(
        this.config.getConfig('ApiBaseURLAWS').concat(`/mmaps/real-estate/uop`),
        {
          headers: {
            Authorization: userInfo.idToken,
            'Content-Type': 'application/json',
          },
        }
      );
    } else {
      return this.httpClient.get(
        this.config.getConfig('ApiBaseURLAWS').concat(`/mmaps/real-estate/uop?search=${search}`),
        {
          headers: {
            Authorization: userInfo.idToken,
            'Content-Type': 'application/json',
          },
        }
      );
    }
  }

  getFundingProjectData(businessUnit: string): any {
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    return this.httpClient.get(
      this.config
        .getConfig('ApiBaseURLAWS')
        .concat(`/mmaps/real-estate/funding?BU=${businessUnit}`),
      {
        headers: {
          Authorization: userInfo.idToken,
          'Content-Type': 'application/json',
        },
      }
    );
  }

  userSearch(searchInput: string) {
    let accessToken = JSON.parse(sessionStorage.getItem('userInfo')).accessToken;
    let listOfHeaders = {
      ConsistencyLevel: 'eventual',
      Authorization: 'Bearer '.concat(accessToken),
    };

    const search = `$search="displayName:${searchInput}"`;

    let url = `https://graph.microsoft.com/v1.0/users?${search}&$select=displayName,givenName,surname,mail,mailNickname,jobTitle&$top=999`;
    return this.getAllGraphResults(url, listOfHeaders);
  }

  assetContactsUserSearch(groupId: string) {
    let accessToken = JSON.parse(sessionStorage.getItem('userInfo')).accessToken;
    let listOfHeaders = {
      ConsistencyLevel: 'eventual',
      Authorization: 'Bearer '.concat(accessToken),
    };
    let url = `https://graph.microsoft.com/v1.0/groups/${groupId}/members?$select=displayName,givenName,surname,mail,mailNickname,jobTitle`;
    return this.httpClient.get(url, { headers: listOfHeaders });
  }

  // use this method when more than 1 page of results is returned from the graph api
  private getAllGraphResults(url: string, headers: any): Promise<any[]> {
    const allResults: any[] = []; // This will hold all the results in a single array

    const fetchPage = (nextUrl: string): Promise<void> => {
      return this.httpClient
        .get(nextUrl, { headers })
        .toPromise()
        .then((response: any) => {
          allResults.push(...response.value); // Add current page results to the array

          if (response['@odata.nextLink']) {
            // If there's a next page, fetch it recursively
            return fetchPage(response['@odata.nextLink']);
          }
        });
    };

    return fetchPage(url).then(() => allResults); // Return the flattened array after all pages are fetched
  }

  /**
   * Fetch Real Estate data for the Real Estate dashboard
   * TODO: Update the endpoint and headers as needed once the backend is ready
   */
  getRealEstateData(callBody: any): any {
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    return this.httpClient.post(
      this.config.getConfig('ApiBaseURLAWS').concat('/mmaps/real-estate/data'),
      callBody,
      {
        headers: {
          Authorization: userInfo.idToken,
          'Content-Type': 'application/json',
        },
      }
    );
  }

  submitRealEstateData(callBody: any): any {
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    return this.httpClient.post(
      this.config.getConfig('ApiBaseURLAWS').concat('/mmaps/real-estate/project/submit'),
      callBody,
      {
        headers: {
          Authorization: userInfo.idToken,
          'Content-Type': 'application/json',
        },
      }
    );
  }

  saveAsDraftRealEstateData(callBody: any): any {
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    return this.httpClient.put(
      this.config.getConfig('ApiBaseURLAWS').concat('/mmaps/real-estate/project'),
      callBody,
      {
        headers: {
          Authorization: userInfo.idToken,
          'Content-Type': 'application/json',
        },
      }
    );
  }

  getProjectData(pId: string): any {
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    return this.httpClient.get(
      this.config.getConfig('ApiBaseURLAWS').concat(`/mmaps/real-estate/project?id=${pId}`),
      {
        headers: {
          Authorization: userInfo.idToken,
          'Content-Type': 'application/json',
        },
      }
    );
  }
}
